import { Autocomplete, TextField } from '@mui/material';
import React from 'react';
import { Calendar } from '../../types/Calendar';

interface Props {
  id: string;
  label: string;
  calendars: Calendar[];
  selectedCalendarId: string;
  onChange: (calendar: Calendar | null) => void;
  loading?: boolean;
  disabled?: boolean;
}

const CalendarAutocompleteSelect: React.FC<Props> = ({ id, label, calendars, selectedCalendarId, onChange, loading = false, disabled = false }) => {
  const selectedCalendar = calendars.find((c) => c.id === selectedCalendarId) || null;

  return (
    <Autocomplete<Calendar>
      id={id}
      options={calendars}
      loading={loading}
      disabled={disabled}
      value={selectedCalendar}
      fullWidth
      onChange={(_, newValue) => {
        onChange(newValue ?? null);
      }}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => <TextField {...params} label={label} />}
      isOptionEqualToValue={(option, value) => option.id === value.id}
    />
  );
};

export default CalendarAutocompleteSelect;
